import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { Suspense } from "react";
import { PROJECT } from "@/app/capabilities/permissions";
import { PlaygroundExecuteToolSkeleton } from "@/app/playground/execute/components/skeletons";
import { PlaygroundExecuteTool } from "@/app/playground/execute/execute";
import {
  defaultInput,
  defaultToolId,
  executeSearchSchema,
} from "@/app/playground/execute/search";
import { requireProjectPermission } from "@/lib/route-guards";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/playground/execute"
)({
  validateSearch: executeSearchSchema,
  search: {
    middlewares: [
      stripSearchParams({ toolId: defaultToolId, input: defaultInput }),
    ],
  },
  component: () => (
    <Suspense fallback={<PlaygroundExecuteToolSkeleton />}>
      <PlaygroundExecuteTool />
    </Suspense>
  ),
  beforeLoad: (ctx) => requireProjectPermission(ctx, PROJECT.tools.execute),
  loader: () => ({
    crumb: "Execute Tool",
  }),
});
